import { useState, useEffect } from 'react';

export function useFoundingCount() {
  const [taken, setTaken] = useState(2);

  useEffect(() => {
    fetch('/api/public/founding-count')
      .then(res => res.json())
      .then(data => setTaken(data.taken ?? 2))
      .catch(() => {});
  }, []);

  return taken;
}
